import { render, staticRenderFns } from "./leifeng-daily.vue?vue&type=template&id=70334bdd&scoped=true&"
import script from "./leifeng-daily.vue?vue&type=script&lang=js&"
export * from "./leifeng-daily.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-daily.vue?vue&type=style&index=0&id=70334bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70334bdd",
  null
  
)

export default component.exports